/* eslint-disable */

import { DefaultBus } from "./core/bus";

import { AppMessage, AppChannel } from "./app";
import { JsonRpcMessage, JsonRpcChannel } from "./jrpc";
import { UnityApi, createUnityApi } from "./unity";

export class Messenger extends DefaultBus {
    private app_: AppChannel | undefined;

    private unity_: UnityApi | undefined;

    setup() {
        this.setupApp();
        this.setupUnity();
    }

    get app() {
        return this.app_;
    }

    get unity() {
        return this.unity_;
    }

    private setupApp() {
        this.app_ = this.open<AppMessage, AppChannel>("local");

        this.app_.subscribe(/./, m => {
            console.log("[local]:", m)
        });
    }

    private setupUnity() {
        if (window.jrpc) {
            const channel = this.open<JsonRpcMessage, JsonRpcChannel>("unity", new JsonRpcChannel());

            channel.subscribe(/./, m => {
                console.log("[unity]:", m)
            });

            this.unity_ = createUnityApi(channel);
        }
    }
}

export const messenger = new Messenger();
